import type { LocaleDictionary } from "@/i18n/types";

const nsViewEN = {
  fallbackName: "View",
  create: "Create View",
  openList: "Open View List",
  configFile: {
    bulkDownload: "Download All Config Files",
    bulkUpload: "Bulk Upload Config Files",
    downloadInProgress: "Downloading config files...",
    downloadSuccess: "Config files downloaded.",
    downloadError: "Failed to download config files.",
  },
  row: {
    editSetting: "View Settings",
    duplicate: "Duplicate View",
    delete: "Delete View",
  },
  listButton: {
    delete: "Delete",
    duplicate: "Duplicate",
  },
  duplicate: {
    inProgress: "Duplicating view...",
    success: "View duplicated.",
    error: "Failed to duplicate view.",
  },
  deleteDialog: {
    title: "Delete View",
    message: ({ viewName }: { viewName: string }) =>
      `"${viewName}" will be deleted. This action cannot be undone.`,
    initialViewWarning:
      "This view is set as the default view. Deleting it will clear this setting.",
    button: "Delete",
    inProgressButton: "Deleting...",
    success: "View deleted.",
    error: "Failed to delete view.",
  },
} satisfies LocaleDictionary;

export default nsViewEN;
